import Swiper from "@modules/swiper";
import { Navigation, A11y, Keyboard, Autoplay } from "@modules/swiper/modules";

/*import '@modules/swiper/css';*/
import "@modules/swiper/modules/a11y";
import "@modules/swiper/modules/keyboard";
import "@modules/swiper/modules/navigation";
import "@modules/swiper/modules/pagination";
import $ from "@modules/jquery";
var language = document.getElementsByTagName("html")[0].getAttribute("lang");
var SlideMessagePrev = language === "it" ? "Mostra immagine precedente" : "Vorheriges Bild anzeigen";
var SlideMessageNext = language === "it" ? "Mostra immagine successiva" : "Nächstes Bild anzeigen";
export function SliderBlock() {

    const swiperSlider = document.querySelector(".primary-slider-block");
    ////console.log(swiperSlider);
    if (swiperSlider) {
        // Crea l'istanza del Swiper
        ////console.log("swiperSlider")
        const swiperInstance = new Swiper(swiperSlider, {
            modules: [Navigation, A11y, Keyboard, Autoplay],
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            loop: true,
            a11y: {
                prevSlideMessage: SlideMessagePrev,
                nextSlideMessage: SlideMessageNext,
            },
            centeredSlides: false,
            loop: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
                pageUpDown: true,
            },
            grabCursor: true,
            navigation: {
                prevEl: '.arrow-left',
                nextEl: '.arrow-right',
            },
            on: {
                init: function () {

                    positionArrowsBelowImage(this);

                },
                slideChange: function () {
                   
                    positionArrowsBelowImage(this);

                },
            },
               
            //on: {
            //    slideChangeTransitionStart: function () {
            //        // Disabilita focus sulle diapositive non attive
            //        document.querySelectorAll('.swiper-slide[aria-hidden="true"]').forEach(slide => {
            //            slide.querySelectorAll('[tabindex]').forEach(el => el.setAttribute('tabindex', '-1'));
            //        });

            //        // Abilita focus sulla diapositiva attiva
            //        const activeSlide = document.querySelector('.swiper-slide:not([aria-hidden="true"])');
            //        if (activeSlide) {
            //            activeSlide.querySelectorAll('[tabindex]').forEach(el => el.removeAttribute('tabindex'));
            //        }
            //    },
           /* },*/
        });

        // Riferimenti ai pulsanti
        const playButton = document.querySelector('.arrow-play');
        const stopButton = document.querySelector('.arrow-stop');
        const updateButtonVisibility = () => {
            if (swiperInstance.autoplay.running) {
                playButton.style.display = 'none'; 
                stopButton.style.display = 'block';
            } else {
                playButton.style.display = 'block'; 
                stopButton.style.display = 'none'; 
            }
        };

        // Aggiungi evento per il pulsante "Play"
        if (playButton) {
            playButton.addEventListener('click', () => {
                swiperInstance.autoplay.start(); 
                updateButtonVisibility()
               
            });
        }

        // Aggiungi evento per il pulsante "Stop"
        if (stopButton) {
            stopButton.addEventListener('click', () => {
                swiperInstance.autoplay.stop(); 
                updateButtonVisibility()
               
            });
        }
        setTimeout(updateButtonVisibility, 0);

        function positionArrowsBelowImage(swiper) {
            const activeSlide = swiper.slides[swiper.activeIndex];
            ////console.log(activeSlide, "activeSlid");
            const image = activeSlide.querySelector("img"); // Seleziona l'immagine nella slide attiva
            ////console.log(image, "image" );
            const frecce = document.querySelector(".frecce");

            if (image && frecce) {
                // Calcola l'altezza dell'immagine dopo il caricamento
                const imageHeight = image.clientHeight;
                ////console.log(imageHeight, "imageHeight" );

                // Posiziona le frecce 30px sotto la base dell'immagine
                const newArrowPosition = imageHeight - 75;
                frecce.style.top = `${newArrowPosition}px`;
                ////console.log(newArrowPosition, "newArrowPosition" );

            }
        }
    }
    window.addEventListener('load', function () {
        setTimeout(() => {
            // Find all elements with the class "swiper-slide"
            var swiperSlides = document.querySelectorAll(".swiper-slide");

            // Loop through each swiper slide
            swiperSlides.forEach(function (slide) {

                // Check if the slide has the "inert" attribute
                if (slide.hasAttribute("inert")) {
                    // Remove the "inert" attribute
                    slide.removeAttribute("inert");
                }
            });

        }, 1000)

    });
}